__webpack_require__.p = "/tokens-tellent-survey/account-setup/";